import React from 'react';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../NotificationPopUp';

import * as authenticationActions from '../../../actions/authenticationActions';
import * as networkActions from '../../../actions/networkActions';

import commonFunctions from '../../../commonFunctions';

class ProductsPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            authenticationState: this.props.authenticationState,
            commonState: this.props.commonState,
            products: []
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history)) {
            return;
        }

        this.lockedOutFormat = this.lockedOutFormat.bind(this);
        this.toMoney = this.toMoney.bind(this);
    }

    componentDidMount() {
        this.props.networkActions.loadActiveNetworkProducts(this.state.authenticationState.network.id).then((products) => {
            this.setState(Object.assign({}, this.state, { products }));
        }).catch(error => {
            notificationPopUp.error('Problemi nel caricamento dei Piani Mutualistici');
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.authenticationState !== prevState.authenticationState || nextProps.commonState !== prevState.commonState)
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState });
        return null;
    }

    lockedOutFormat(cell, row) {
        if (cell)
            return 'IN USO';
        return 'NON IN USO';
    }

    toMoney(cell, row) {
        return (
            <div>{commonFunctions.numberToItalianEuroFormat(cell)}</div>
        );
    }

    render() {
        const gridOptions = {
            sizePerPageList: [5, 10, 20, 50]
        };

        return (
            <div className='container'>
                <h1>Piani Mutualistici</h1>
                <div className="row">
                    <BootstrapTable data={this.state.products} options={gridOptions} striped hover pagination>
                        <TableHeaderColumn isKey dataField='id' hidden>Id</TableHeaderColumn>
                        <TableHeaderColumn dataField='name' dataSort>Denominazione</TableHeaderColumn>
                        <TableHeaderColumn dataField='code' dataSort>Codice</TableHeaderColumn>
                        <TableHeaderColumn dataField='costoLordo' dataSort dataFormat={this.toMoney}>Contributo Annuale</TableHeaderColumn>
                        <TableHeaderColumn dataField='lockedOut' dataFormat={this.lockedOutFormat} dataSort>Modificabile</TableHeaderColumn>
                    </BootstrapTable>
                    <div className="panel panel-default x-panel">
                        <div className="panel-heading">Piani Mutualistici - Altre Convenzioni</div>
                        <div className="panel-body">
                            <ul>
                                <li><a href='https://vegass2000.com:8443/wd2/zk/IsMainZK?PROGRAM=VEGACDS' target="_blank" rel="noopener noreferrer">UNIQA</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        authenticationState: state.authenticationState,
        commonState: state.commonState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        networkActions: bindActionCreators(networkActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
